import React from "react";

interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13639_27415)">
        <path
          d="M5 9.75V38.25C5 39.5098 5.50044 40.718 6.39124 41.6088C7.28204 42.4996 8.49022 43 9.75 43H38.25C39.5098 43 40.718 42.4996 41.6088 41.6088C42.4996 40.718 43 39.5098 43 38.25V9.75C43 8.49022 42.4996 7.28204 41.6088 6.39124C40.718 5.50044 39.5098 5 38.25 5H9.75C8.49022 5 7.28204 5.50044 6.39124 6.39124C5.50044 7.28204 5 8.49022 5 9.75ZM16.875 40.625H9.75C9.12011 40.625 8.51602 40.3748 8.07062 39.9294C7.62522 39.484 7.375 38.8799 7.375 38.25V35.875H16.875V40.625ZM16.875 33.5H7.375V28.75H16.875V33.5ZM16.875 26.375H7.375V21.625H16.875V26.375ZM28.75 33.5H19.25V28.75H28.75V33.5ZM28.75 19.25H19.25V14.5H28.75V19.25ZM38.25 40.625H31.125V35.875H40.625V38.25C40.625 38.8799 40.3748 39.484 39.9294 39.9294C39.484 40.3748 38.8799 40.625 38.25 40.625ZM40.625 33.5H31.125V28.75H40.625V33.5ZM40.625 26.375H31.125V21.625H40.625V26.375ZM40.625 12.125H31.125V7.375H38.25C38.8799 7.375 39.484 7.62522 39.9294 8.07062C40.3748 8.51602 40.625 9.12011 40.625 9.75V12.125Z"
          fill="#252C34"
        />
      </g>
      <defs>
        <clipPath id="clip0_13639_27415">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
